module.exports = __webpack_public_path__ + "img/img_body_biz_lguplus_logo.2f04c42e.png";